import { cx } from '../../lib/cx.js';
import { exactTime, relativeAge, relativeLabel } from '../../lib/format.js';

/** Compact age with the exact timestamp on hover, as the design brief asks. */
export function RelativeTime({
  value,
  className,
  withSuffix,
}: {
  value: string | Date | null | undefined;
  className?: string;
  withSuffix?: boolean;
}) {
  if (value === null || value === undefined) {
    return <span className={cx('text-[var(--text-3)]', className)}>—</span>;
  }
  const iso = value instanceof Date ? value.toISOString() : value;
  return (
    <time dateTime={iso} title={exactTime(value)} className={cx('tnum', className)}>
      {withSuffix ? relativeLabel(value) : relativeAge(value)}
    </time>
  );
}

export function AbsoluteTime({
  value,
  className,
}: {
  value: string | Date | null | undefined;
  className?: string;
}) {
  if (value === null || value === undefined) {
    return <span className={cx('text-[var(--text-3)]', className)}>—</span>;
  }
  const iso = value instanceof Date ? value.toISOString() : value;
  return (
    <time dateTime={iso} className={cx('tnum', className)}>
      {exactTime(value)}
    </time>
  );
}
